import React, { useEffect } from 'react'
import logo from '../../Assets/logo-bpk-penabur.webp'

function ScoreBoardTemplate(props) {

    let match = props.match
    let showModalFunc = props.toggleModal

    const firstQuarter = () => {
        if (match.quarter11) {
            return [match.quarter11, match.quarter12]
        }
    }

    const secondQuarter = () => {
        if (match.quarter21) {
            return [match.quarter21, match.quarter22]
        }
    }

    const thirdQuarter = () => {
        if (match.quarter31) {
            return [match.quarter31, match.quarter32]
        }
    }

    const fourthQuarter = () => {
        if (match.quarter41) {
            return [match.quarter41, match.quarter42]
        }
    }

    const combinedArray = [firstQuarter(), secondQuarter(), thirdQuarter(), fourthQuarter()];



    return (

        <div className='w-full text-center py-5'>
                {/* <span className='inline-flex gap-[10px] max-w-screen w-full text-center overflow-x-hidden relative'
                    data-aos="fade-left"
                    data-aos-offset="100"
                    data-aos-duration="2000"
                    data-aos-delay="0"
                    alt=""
                >
                    <p className='lg:text-[80px] text-[40px] font-[700] text-white justify-start font-[BebasNeue] my-auto'></p>
                    <svg className='w-full mx-[10px]'>
                        <line className='grow' x1='0' y1='80px' x2='100%' y2='80px' stroke='white' fill='white'/>
                    </svg>
                </span> */} 
            <div className="grid grid-cols-5 border-[5px] border-[#E09D42] bg-[#fff2cc] row-span-1 text-center align-middle items-center h-auto mx-5 p-5 lg:p-12"
                data-aos="fade-right"
                data-aos-offset="100"
                data-aos-duration="2000"
                data-aos-delay="0"
                alt=""
            >
                    <span className={`text-black text-center font-[clashdisplay] font-bold text-2xl lg:text-[80px]`}>{match.score1}</span>
                <div className='flex flex-col'>
                    {/* <img src={logo} width={360} height={360} className='scale-150 lg:scale-100 mb-2'/> */}
                    <span className='text-black text-center font-[clashdisplay] text-xs lg:text-3xl'>{match.team1}</span>
                </div>
                
                

                <div className='relative flex flex-col h-12 text-black text-center items-center justify-center'>
                    <span className='text-2xl lg:text-[80px] font-[clashdisplaybold]'>VS</span>
                    <button className='absolute -bottom-3 lg:-bottom-10 font-[manrope] text-sm lg:text-2xl h-5 lg:h-8 w-5 lg:w-8 bg-[#E09D42] border-black border-[1px]' onClick={() => showModalFunc(true, match.team1, match.team2, combinedArray)}>
                        i
                    </button>
                </div>
                
                <div className='flex flex-col'>
                    {/* <img src={logo} width={360} height={360} className='scale-150 lg:scale-100 mb-2'/> */}
                    <span className='text-black text-center font-[clashdisplay] text-xs lg:text-3xl'>{match.team2}</span>
                </div>
                <div>
                    <span className={`text-black text-center font-[clashdisplay] font-bold text-2xl lg:text-[80px]`}>{match.score2}</span>
                </div>
                

                
                
                </div>
            </div>  

    )
}

export default ScoreBoardTemplate;